/* NotFound.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ErrorTemplate } from '../ErrorTemplate';
import { locale } from '../locale';
import { RedirectLink } from '../RedirectLinks';
import NotFoundSvg from './NotFound.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._1tke1kw7{min-height:inherit}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const NotFoundWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  NotFoundWrapper.displayName = 'NotFoundWrapper';
}
export const NotFound = () => {
  return /*#__PURE__*/_jsx(NotFoundWrapper, {
    children: /*#__PURE__*/_jsx(ErrorTemplate, {
      heading: locale.notFound.heading,
      image: NotFoundSvg,
      children: /*#__PURE__*/_jsxs("span", {
        children: [locale.notFound.pageNotExist, " ", /*#__PURE__*/_jsx(RedirectLink, {
          href: "/",
          children: locale.homePage
        })]
      })
    })
  });
};